import { useEffect, useState } from "react";
import api from "@/lib/api";

const cache = new Map();

export function useContent(section, defaults = {}) {
    const [data, setData] = useState(cache.get(section) || defaults);
    const [loading, setLoading] = useState(!cache.has(section));

    useEffect(() => {
        let cancelled = false;
        api.get(`/content/${section}`)
            .then((r) => {
                if (cancelled) return;
                const merged = { ...defaults, ...r.data.data };
                cache.set(section, merged);
                setData(merged);
            })
            .catch(() => {})
            .finally(() => !cancelled && setLoading(false));
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [section]);

    return { data, loading };
}

export function clearContentCache() {
    cache.clear();
}
